import dayjs from 'dayjs';
import {
  AutoSinistreDTO,
  IError,
} from '../../types/interface/Sinistres/autoMoto';

export const TitleLabels = {
  infos: {
    numeroContrat: 'Numéro de contrat',
    immatriculation: 'N° Immatriculation',
    dateAccident: "Date de l'accident",
    agence: 'Agence ARO gestionnaire du contrat',
    telephone: 'N° téléphone',
    circonstanceAccident: "Circonstances et causes de l'accident",
    photo: "Photo(s) de l'accident",
    pieceJointeAgence: "Pièce(s) à fournir à joindre ou à déposer à l'agence",
  },
};

export const showErrorValuesDefault = {
  numeroContrat: false,
  immatriculation: false,
  dateAccident: false,
  agence: false,
  telephone: false,
  circonstanceAccident: false,
  photo: false,
  pieceJointeAgence: false,
};

export const showErrorValuesSubmit = {
  numeroContrat: true,
  immatriculation: true,
  dateAccident: true,
  agence: true,
  telephone: true,
  circonstanceAccident: true,
  photo: true,
  pieceJointeAgence: true,
};

export const defaultAutoSinistreError: IError = {
  numeroContrat: '',
  immatriculation: '',
  dateAccident: '',
  agence: '',
  telephone: '',
  circonstanceAccident: '',
  photo: '',
  pieceJointeAgence: '',
};

export const defaultAutoSinistreValue: AutoSinistreDTO = {
  numeroContrat: '',
  immatriculation: '',
  dateAccident: dayjs().startOf('date').toDate(),
  agence: '',
  telephone: '',
  circonstanceAccident: '',
  photo: '',
  pieceJointeAgence: '',
};
